import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Typography
} from 'antd';
import BreadcrumbList from '@modules/Sellers/Stock/components/Breadcrumb';
import { formatDateTime } from '@utils/helpers/formatDate';
import deliveryService from '@modules/Warehouse/Delivery/services/delivery';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import { DownOutlined } from '@ant-design/icons';
import metaApi from '@core/components/CountryPhoneInput/meta-service';
import Popup from '@core/components/Popup';
import CommentDeliveryUpdate from '../components/CommentDeliveryUpdate';
import commentService from '@root/core/components/CommentTabs/commentService';

const { Option } = Select;
const { Title, Paragraph, Text, Link } = Typography;

const breadcrumbList = [
  {
    tittle: 'Delivery',
    url: '/admin/delivery'
  },
  {
    tittle: 'Detailed Delivery',
    url: ''
  }
];

interface ICountry {
  calling_code: string;
  flag: string;
  id: number;
  language: string;
  lookupCode: string;
  lookupCodeId: string;
  priority: string;
  value: string;
}

const UpdateDelivery = () => {
  const { idDelivery, commentId }: any = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [listPro, setListPro] = useState([] as any);
  const [listDetail, setListDetail] = useState([] as any);
  const [form] = Form.useForm();
  const [countryCodes, setCountryCodes] = useState<ICountry[]>([] as any);
  const [popupConfirm, setPopupConfirm] = useState(false);
  const [dataToUpdate, setDataToUpdate] = useState({ products: [] } as any);

  const _getCountry = async () => {
    const responseData = await metaApi['getMetaData']();

    const reOrderData = [...responseData?.data.country_code];
    const slie = listDetail?.recipientCountryCode?.replace('+', '');
    const fill = reOrderData.filter(
      (item: any) => item.lookupCodeId === listDetail?.recipientCountryCode
    );
    setCountryCodes(fill);
  };

  const _getDetailDe = async () => {
    setLoading(true);
    const detialDe = await deliveryService.getDetailDelivery(idDelivery);

    if (detialDe.message === 'success') {
      setListDetail(detialDe.data);
      setListPro([...detialDe?.data?.products]);
      setDataToUpdate({
        products: [...detialDe?.data?.products],
        ...detialDe.data,
      })
      setLoading(false);
    }
    setLoading(false);
  };

  const handleConfirmEdit = async () => {
    setPopupConfirm(false);
    setLoading(true);
    await deliveryService.updateDelivery(idDelivery, dataToUpdate);
    await commentService.editedRequest(commentId);
    history.push('/admin/delivery');
  };

  useEffect(() => {
    _getDetailDe();
  }, []);

  useEffect(() => {
    _getCountry();
  }, [listDetail?.recipientCountryCode]);

  useEffect(() => {
    const mapProductComment: any = listDetail;

    form.setFieldsValue({
      orderNumber: mapProductComment.orderNumber,
      buyerName: mapProductComment.buyerName,
      recipientName: mapProductComment.recipientName,
      orderDate: moment(mapProductComment.orderDate)
        .utc()
        .format('YYYY-MM-DD hh:mm:ss'),
      buyerEmail: mapProductComment.buyerEmail,
      shippingAddress: mapProductComment.shippingAddress,
      saleChannel: mapProductComment.saleChannel,
      recipientPhone: mapProductComment.recipientPhone,
      street: mapProductComment.shippingAddress,
      postalCode: mapProductComment.postalCode,
      country: mapProductComment.country,
      detailAddress: mapProductComment.detailAddress,
      detailAddress2: mapProductComment.detailAddress2,
      city: mapProductComment.city,
      state: mapProductComment.state,
    });
  }, [listDetail]);

  return (
    <>
      <Spin spinning={loading}>
        <BreadcrumbList listBreadcrumb={breadcrumbList} />
        <div className="admin-container ">
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              background: 'none'
            }}
          >
            <div className="detailDelivery">
              <div className="wrapTitle">
                <p className="updateDeli">
                  Update Date :{formatDateTime(listDetail?.updatedAt)}
                </p>

                <p className="statusDe">
                  <span>
                    {listDetail?.status === 'Inprogress'
                      ? 'In Progress'
                      : listDetail?.status === 'Complete'
                      ? 'Complete'
                      : 'Request'}
                  </span>
                </p>
              </div>
              <div className="infoDeli">
                <Button
                  style={{
                    float: 'right',
                    border: 'none',
                    borderBottom: '1px solid black',
                    color: '#2B2C51'
                  }}
                  onClick={() => setPopupConfirm(true)}
                >
                  Save
                </Button>

                <Form form={form} layout="vertical">
                  <Row className="rowDeliver">
                    <Col span={7}>
                      <Form.Item label="Order Number" name="orderNumber">
                        <Input className="border-input" disabled />
                      </Form.Item>
                      <Form.Item label="Buyer Name" name="buyerName">
                        <Input className="border-input" disabled />
                      </Form.Item>
                    </Col>
                    <Col span={7}>
                      <Form.Item label="Order Date" name="orderDate">
                        <Input className="border-input" disabled />
                      </Form.Item>
                      <Form.Item label="Buyer Email" name="buyerEmail">
                        <Input className="border-input" disabled />
                      </Form.Item>
                    </Col>
                    <Col span={7}>
                      <Form.Item
                        label="Online Website"
                        style={{ width: '100%' }}
                        className="rowOnlineWeb"
                        name="saleChannel"
                      >
                        <Select className="border-input" disabled>
                          <Option value="true">YES</Option>
                          <Option value="false">NO</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={7}>
                      <Form.Item label="Recipient Name" name="recipientName">
                        <Input className="border-input" disabled />
                      </Form.Item>
                    </Col>
                    <Col span={5} style={{ paddingLeft: '10px' }}>
                      <Form.Item
                        label="Shipping Country/Address"
                        name="country"
                      >
                        <Input className="border-input" disabled />
                      </Form.Item>
                    </Col>
                    <Col span={12} style={{ paddingLeft: '10px' }}>
                      <Form.Item label=" " name="shippingAddress">
                        <Input className="border-input" disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={7} className="rowPhoneNumber">
                      <Form.Item label="Recipient Phone Number">
                        <Input.Group
                          style={{ display: 'flex', flexDirection: 'row' }}
                        >
                          <Text keyboard className="textCountry" disabled>
                            {countryCodes.map((item: any) => (
                              <div
                                key={item.countryCode}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                {' '}
                                <img
                                  src={item.flag}
                                  alt=""
                                  width={24}
                                  height={24}
                                />
                                +{item.calling_code}
                                <DownOutlined />
                              </div>
                            ))}
                          </Text>

                          <Form.Item
                            name="recipientPhone"
                            style={{ width: '100%' }}
                          >
                            <Input className="border-input" disabled />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col span={17} style={{ paddingLeft: '10px' }}>
                      <Row style={{ marginTop: '-35px' }}>
                        <Col span={12}>
                          <Form.Item label=" " name="detailAddress2">
                            <Input className="border-input" disabled />
                          </Form.Item>
                        </Col>
                        <Col span={12} style={{ paddingLeft: '10px' }}>
                          <Form.Item label=" " name="detailAddress">
                            <Input className="border-input" disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row style={{ marginTop: '-35px' }}>
                        <Col span={8}>
                          <Form.Item label=" " name="city">
                            <Input className="border-input" disabled />
                          </Form.Item>
                        </Col>
                        <Col span={8} style={{ paddingLeft: '10px' }}>
                          <Form.Item label=" " name="state">
                            <Input className="border-input" disabled />
                          </Form.Item>
                        </Col>
                        <Col span={8} style={{ paddingLeft: '10px' }}>
                          <Form.Item label=" " name="postalCode">
                            <Input className="border-input" disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </div>

              <div className="wrapDelivery">
                {listPro.map((item: any) => (
                  <div className="proDelivery">
                    {' '}
                    <Form
                      layout="vertical"
                      onFieldsChange={(e: any) => {
                        const products = [...dataToUpdate.products];
                        products.forEach((product, i) => {
                          products[i][e[0].name[0]] = e[0].value;
                        });
                        setDataToUpdate({
                          ...dataToUpdate,
                          products
                        });
                      }}
                      initialValues={{
                        id: item.id,
                        productName: item.productName,
                        sku: item.sku,
                        eanUpc: item.eanUpc,
                        quantity: item.quantity
                      }}
                    >
                      <Row className="rowDeliver">
                        <Col span={10}>
                          <Form.Item label="Product Name" name="productName">
                            <Input className="border-input" />
                          </Form.Item>
                          <Form.Item
                            label="Product Name"
                            name="id"
                            style={{ display: 'none' }}
                          >
                            <Input className="border-input" />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item label="SKU" name="sku">
                            <Input className="border-input" />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item label="EAN/UPC" name="eanUpc">
                            <Input className="border-input" />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item label="Quantity" name="quantity">
                            <Input className="border-input" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                ))}
              </div>

              <CommentDeliveryUpdate
                onchange={(data: any) => {
                  setDataToUpdate({
                    ...dataToUpdate,
                    ...data
                  });
                }}
                listDetail={listDetail}
              />
            </div>
          </Card>
        </div>
      </Spin>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={popupConfirm}
        textCancel="Cancel "
        textOk="Confirm"
        title={'Would you like to save?'}
        action_oke={() => handleConfirmEdit()}
        action_cancel={() => setPopupConfirm(false)}
      />
    </>
  );
};

export default UpdateDelivery;
